import React, { useEffect } from "react";
import Routes from "../Routes";
import "../../assets/icons/style.scss";
import "../../assets/scss/common/common.scss";
import "../../assets/scss/variables/fontFamily.scss";
import config from "../../config/domain";

const App = () => {
  useEffect(() => {
    window.clevertap.account.push({ id: config.cleverTapId });
    window.clevertap.privacy.push({ optOut: false }); //set the flag to true, if the user of the device opts out of sharing their data
    window.clevertap.privacy.push({ useIP: false }); //set the flag to true, if the user agrees to share their IP data
    (function () {
      var wzrk = document.createElement("script");
      wzrk.type = "text/javascript";
      wzrk.async = true;
      wzrk.src = "lib/clevertap.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(wzrk, s);
    })();

    window.clevertap.notifications.push({
      titleText: "Would you like to receive Push Notifications?",
      bodyText:
        "We promise to only send you relevant content and give you updates on your transactions",
      okButtonText: "Sign me up!",
      rejectButtonText: "No thanks",
      okButtonColor: "#f28046",
      askAgainTimeInSeconds: 172800,
      serviceWorkerPath: "/serviceworker.js",
    });
  }, []);
  return (
    <div>
      <Routes />
    </div>
  );
};

export default App;
